.tile {
  flex: 1 0 0;
  min-width: 0;
}
